import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Solución para ChunkLoadError - recarga automáticamente cuando fallan los chunks
window.addEventListener('error', function (event) {
  if (event.message && event.message.includes('Loading chunk')) {
    window.location.reload();
  }
});

window.addEventListener('unhandledrejection', function (event) {
  if (event.reason && event.reason.toString().includes('ChunkLoadError')) {
    window.location.reload();
  }
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
